import { render, staticRenderFns } from "./ExchangeContractForm.vue?vue&type=template&id=54c54207&"
import script from "./ExchangeContractForm.vue?vue&type=script&lang=js&"
export * from "./ExchangeContractForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports